import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {EnvService} from "../services/env.service";
import {HttpClient} from "@angular/common/http";

@Component({
  selector: 'micro-client-grant-select',
  templateUrl: './client-grant-select.component.html'
})
export class ClientGrantSelectComponent implements OnInit  {
  grants:any[];
  @Input() simple:boolean = false;
  @Input() placeholder:string = 'Grant';

  @Output()
  grantChange:EventEmitter<any> = new EventEmitter<any>();

  @Input()
  grant:any = '';

  change(e) {
    this.grantChange.emit(e);
  }

  constructor(private env:EnvService, private http:HttpClient) {
  }

  ngOnInit() {
    this.http.get(`${this.env.e.url}/auth/clients/grants`).subscribe(
      data => {
        this.grants = data as any[];
      }
    );
  }
}
